"use client";

import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { GroupLabelContext } from "./7HVFURXT.js";
import { createElement, createHook, forwardRef } from "./7FZLUSKW.js";
import { useWrapElement } from "./HNHAUIIY.js";
import { __spreadValues } from "./3YLGPPWQ.js";

// src/group/group.tsx
import { removeUndefinedValues } from "@ariakit/core/utils/misc";
import { useState } from "react";
import { jsx } from "react/jsx-runtime";
var TagName = "div";
var useGroup = createHook(function useGroup2(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    labelId = _useState2[0],
    setLabelId = _useState2[1];
  props = useWrapElement(props, function (element) {
    return /* @__PURE__ */jsx(GroupLabelContext.Provider, {
      value: setLabelId,
      children: element
    });
  }, []);
  props = __spreadValues({
    role: "group",
    "aria-labelledby": labelId
  }, props);
  return removeUndefinedValues(props);
});
var Group = forwardRef(function Group2(props) {
  var htmlProps = useGroup(props);
  return createElement(TagName, htmlProps);
});
export { useGroup, Group };